import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AudioChatCardComponent } from './components/audio-chat-card/audio-chat-card.component';
import { AudioRecorderComponent } from './components/audio-recorder/audio-recorder.component';

@NgModule({
  declarations: [AudioRecorderComponent, AudioChatCardComponent],
  imports: [CommonModule, FontAwesomeModule],
  providers: [],
  exports: [AudioRecorderComponent, AudioChatCardComponent]
})
export class AudioModule {}
